import {
  RISK_MODERATE_LIMIT,
  RISK_HIGH_LIMIT,
  RISK_ELEVATED_LIMIT,
  RISK_SIGNIFICANT_LIMIT,
  RISK_VERY_HIGH_LIMIT,
  RISK_EXTREME_LIMIT,
} from '@/constants';
import { ProgressColor } from '@/types';

export const getRiskColor = (riskScore: number): ProgressColor => {
  if (riskScore < RISK_MODERATE_LIMIT) return 'low';
  if (riskScore >= RISK_MODERATE_LIMIT && riskScore < RISK_ELEVATED_LIMIT)
    return 'moderate';
  if (riskScore >= RISK_ELEVATED_LIMIT && riskScore < RISK_SIGNIFICANT_LIMIT)
    return 'elevated';
  if (riskScore >= RISK_SIGNIFICANT_LIMIT && riskScore < RISK_HIGH_LIMIT)
    return 'significant';
  if (riskScore >= RISK_HIGH_LIMIT && riskScore < RISK_VERY_HIGH_LIMIT)
    return 'high';
  if (riskScore >= RISK_VERY_HIGH_LIMIT && riskScore < RISK_EXTREME_LIMIT)
    return 'veryHigh';

  return 'extreme';
};
